import { render, staticRenderFns } from "./IpSubnets.vue?vue&type=template&id=6ffe4fd7"
import script from "./IpSubnets.vue?vue&type=script&lang=js"
export * from "./IpSubnets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports